/**
 * @desc 修改料耗比
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: defs.MaterialConsumptionThanNewParameters,
): Promise<defs.StandardReturn<string>> {
  return defHttp.post({
    url: '/web/consumptionRatio/update',
    data,
  });
}

export function mock(
  data: defs.MaterialConsumptionThanNewParameters,
): Promise<defs.StandardReturn<string>> {
  return defHttp.post({
    url: '/mock/web/consumptionRatio/update',
    data,
  });
}
